/* Gudsip homepage behaviour, ported from index18.html. Loaded by layout/gudsip.liquid after GSAP, ScrollTrigger and Lenis. */
(() => {
  'use strict';

  /* Store data written by layout/gudsip.liquid: asset URLs, cart routes, money format, UI strings. */
  const CFG = window.GUDSIP || {};
  const ROUTES = CFG.routes || { cart: '/cart', add: '/cart/add', change: '/cart/change' };
  const T = CFG.t || {};
  const DESIGN = !!(window.Shopify && window.Shopify.designMode);
  const FLAVOR_COLOR = { strawberry: '#D91F2E', chocolate: '#5A2614' };
  // the packet mascot holds the flavour's own milk (pink glass / chocolate glass)
  const MASCOT = CFG.mascot || {};

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const html = document.documentElement;
  const body = document.body;
  // prices arrive in cents; formatted with the shop's own money format (Settings > Store details)
  function money(cents) {
    const n = (Number(cents) || 0) / 100;
    const num = (d, th, dec) => { const [i, f] = n.toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? dec + f : ''); };
    const fmt = String(CFG.moneyFormat || '₹{{amount_no_decimals}}').replace(/<[^>]*>/g, '');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: num(2, ',', '.'), amount_no_decimals: num(0, ',', '.'),
      amount_with_comma_separator: num(2, '.', ','), amount_no_decimals_with_comma_separator: num(0, '.', ','),
      amount_with_apostrophe_separator: num(2, "'", '.'), amount_with_space_separator: num(2, ' ', ',')
    })[k] || num(2, ',', '.'));
  }
  const clamp = (n, lo, hi) => Math.min(hi, Math.max(lo, Number.isFinite(n) ? Math.round(n) : lo));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const hasGSAP = !!(window.gsap && window.ScrollTrigger);
  const motion = hasGSAP && !reduce;
  if (motion) gsap.registerPlugin(ScrollTrigger); else html.classList.add('static-motion');

  /* ---------- Smooth scroll ---------- */
  let lenis = null;
  if (window.Lenis && motion && fine) {
    lenis = new Lenis({ lerp: 0.11 });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(t => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
  }
  let menuOpen = false;
  let cartOpen = false;
  function syncLock() {
    const lock = menuOpen || cartOpen || html.classList.contains('is-loading');
    body.classList.toggle('is-locked', lock);
    if (lenis) { if (lock) lenis.stop(); else lenis.start(); }
  }
  function scrollToTarget(target) {
    if (lenis) lenis.scrollTo(target, { duration: 1.4 });
    else target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
  }
  // in-page links: "#faq", and links to this same page such as "/#faq" from a Shopify menu
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="#"]');
    if (!a || a.target === '_blank') return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.hash.length < 2) return;
    let target = null;
    try { target = document.querySelector(decodeURIComponent(url.hash)); } catch { return; }
    if (!target) return;
    e.preventDefault();
    const wasOpen = menuOpen || cartOpen;
    if (menuOpen) setMenu(false);
    if (cartOpen) closeCart();
    setTimeout(() => scrollToTarget(target), wasOpen ? 350 : 0);
  });

  /* ---------- Magnetic buttons ---------- */
  if (fine && !reduce) {
    $$('.magnetic').forEach(el => {
      el.addEventListener('pointermove', e => {
        const r = el.getBoundingClientRect();
        el.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.25}px,${(e.clientY - r.top - r.height / 2) * 0.35}px)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });
  }

  /* ---------- Nav: hide on scroll down, menu overlay ---------- */
  const nav = $('.nav');
  const menu = $('#menu');
  const menuBtn = $('.nav__menu');
  menu.inert = true;
  let lastY = window.scrollY;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    nav.classList.toggle('is-hidden', !nav.hasAttribute('data-pinned') && y > lastY && y > 260 && !menuOpen && !cartOpen);
    nav.classList.toggle('is-scrolled', y > 40);
    lastY = y;
  }, { passive: true });
  function setMenu(open) {
    menuOpen = open;
    const r = menuBtn.getBoundingClientRect();
    menu.style.setProperty('--mx', (r.left + r.width / 2) + 'px');
    menu.style.setProperty('--my', (r.top + r.height / 2) + 'px');
    menu.classList.toggle('is-open', open);
    menu.inert = !open;
    menu.setAttribute('aria-hidden', String(!open));
    menuBtn.setAttribute('aria-expanded', String(open));
    $('span', menuBtn).textContent = open ? (T.close || 'Close') : (T.menu || 'Menu');
    if (open) nav.classList.remove('is-hidden');
    html.classList.toggle('menu-open', open);
    syncLock();
    if (open) setTimeout(() => $('.menu__links a').focus(), 450);
  }
  menuBtn.addEventListener('click', () => setMenu(!menuOpen));

  /* ---------- Flavour state + liquid wipe ---------- */
  const wipe = $('.wipe');
  let wiping = false;
  function applyFlavor(f) {
    body.dataset.flavor = f;
    if (MASCOT[f]) $$('img[data-mascot]').forEach(img => { img.src = MASCOT[f]; });
    $$('[data-flavor-go], [data-set-flavor]').forEach(b => b.setAttribute('aria-checked', String((b.dataset.flavorGo || b.dataset.setFlavor) === f)));
    const themeColor = $('meta[name="theme-color"][data-flavour-color]');
    if (themeColor) themeColor.setAttribute('content', FLAVOR_COLOR[f]);
    document.dispatchEvent(new CustomEvent('gud:flavor', { detail: f }));
  }
  function goFlavor(f) {
    if (!FLAVOR_COLOR[f] || body.dataset.flavor === f || wiping) return;
    applyFlavor(f); // no full-screen wipe: the page recolours in place
  }
  document.addEventListener('click', e => {
    const go = e.target.closest('[data-flavor-go]');
    if (go) goFlavor(go.dataset.flavorGo);
    const set = e.target.closest('[data-set-flavor]');
    if (set) applyFlavor(set.dataset.setFlavor);
  });

  // pages can open in either flavour (body data-flavor; the Shopify layout sets it from the product)
  if (body.dataset.flavor !== 'strawberry') applyFlavor(body.dataset.flavor);

  /* ---------- Hero: 3D tilt + parallax ---------- */
  // a page can hold more than one hero section; each one tilts its own pack
  const hero = $('.hero');
  if (fine && !reduce) $$('.hero').forEach(sec => {
    const tilt = $('[data-stage-pack]', sec);
    const depthEls = $$('[data-depth]', sec);
    if (!tilt) return;
    sec.addEventListener('pointermove', e => {
      const r = sec.getBoundingClientRect();
      const nx = (e.clientX - r.left) / r.width - 0.5;
      const ny = (e.clientY - r.top) / r.height - 0.5;
      tilt.style.setProperty('--ry', (nx * 26).toFixed(2) + 'deg');
      tilt.style.setProperty('--rx', (-ny * 18).toFixed(2) + 'deg');
      depthEls.forEach(el => { const d = Number(el.dataset.depth); el.style.translate = `${(nx * d * 60).toFixed(1)}px ${(ny * d * 60).toFixed(1)}px`; });
    });
    sec.addEventListener('pointerleave', () => {
      tilt.style.setProperty('--ry', '0deg');
      tilt.style.setProperty('--rx', '0deg');
      depthEls.forEach(el => { el.style.translate = ''; });
    });
  });
  function heroIntro() {
    if (!motion || !hero) return;
    gsap.from('.hero__title .line > span', { yPercent: 115, rotate: 4, duration: 1.1, ease: 'power4.out', stagger: 0.09, delay: 0.2 });
    gsap.from('.hero [data-intro]', { y: 30, opacity: 0, duration: 0.9, ease: 'power3.out', stagger: 0.08, delay: 0.45 });
    gsap.from('.stage__intro', { y: 140, scale: 0.8, rotate: 10, opacity: 0, duration: 1.3, ease: 'back.out(1.4)', delay: 0.3 });
    // Only pop in what the current flavour shows; clearing props afterwards hands control back to the CSS.
    const pops = $$('.hero .float, .stage__mascot, .stage__badge').filter(el => getComputedStyle(el).opacity !== '0');
    gsap.fromTo(pops, { scale: 0, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.9, ease: 'back.out(2)', stagger: 0.05, delay: 0.7, clearProps: 'transform,opacity,scale,rotate,translate' });
  }

  /* ---------- Loader ---------- */
  const loader = $('.loader');
  function hideLoader() {
    if (!loader || loader.classList.contains('is-done')) return;
    loader.classList.add('is-done');
    html.classList.remove('is-loading');
    syncLock();
    setTimeout(() => loader.remove(), 1100);
    heroIntro();
  }
  if (html.classList.contains('loader-seen')) {
    if (loader) loader.remove();
    html.classList.remove('is-loading');
    syncLock();
  } else if (reduce || DESIGN || !loader) {
    hideLoader();
  } else {
    // Only wait for what the first screen needs (hero pack, mascot, logo), not the whole page.
    const bar = $('.loader__bar span');
    const first = [$(`.stage__pack[data-for="${body.dataset.flavor}"]`), $('.stage__mascot img'), $('.nav__logo img')].filter(Boolean);
    let done = 0;
    const tick = () => { done++; bar.style.width = Math.round((done / first.length) * 100) + '%'; };
    const ready = img => (img.decode ? img.decode() : Promise.resolve()).catch(() => {}).then(tick);
    const start = performance.now();
    Promise.all(first.map(ready)).then(() => setTimeout(hideLoader, Math.max(0, 450 - (performance.now() - start))));
    setTimeout(hideLoader, 1600);
  }
  syncLock();

  /* ---------- Starburst sticker ---------- */
  $$('[data-burst]').forEach(poly => {
    const n = Number(poly.dataset.burst) || 18, R = 48, r = 40;
    poly.setAttribute('points', Array.from({ length: n * 2 }, (_, i) => {
      const a = (Math.PI * i) / n - Math.PI / 2, d = i % 2 ? r : R;
      return (50 + d * Math.cos(a)).toFixed(1) + ',' + (50 + d * Math.sin(a)).toFixed(1);
    }).join(' '));
  });

  /* ---------- Stickers: drop in, drag around ---------- */
  // one sticker wall per promise section; mouse and touch both drag, and a sticker can't leave its wall or the screen
  let stickerZ = 10;
  $$('.stickers').forEach(wall => {
    const stickers = $$('.sticker', wall);
    if (motion) {
      gsap.from($$('.spot__in', wall), { scale: 0.6, y: 60, opacity: 0, duration: 1.1, ease: 'back.out(1.5)', scrollTrigger: { trigger: wall, start: 'top 80%' } });
      gsap.from(stickers, { y: -180, rotation: () => gsap.utils.random(-40, 40), opacity: 0, duration: 1, ease: 'back.out(1.6)', stagger: 0.08, delay: 0.25, scrollTrigger: { trigger: wall, start: 'top 78%' } });
    }
    const pack = $('.spot__in', wall);
    stickers.forEach(st => {
      let sx = 0, sy = 0, ox = 0, oy = 0, cx = 0, cy = 0, dragging = false, lim = null, blocked = () => false;
      st.addEventListener('pointerdown', e => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true;
        st.setPointerCapture(e.pointerId);
        sx = e.clientX; sy = e.clientY;
        ox = cx = Number(st.dataset.x) || 0; oy = cy = Number(st.dataset.y) || 0;
        // travel limits, measured before the lift-up scale (1.1) kicks in; that grows the sticker by 5% on each
        // side, which has to stay inside the wall and the screen too
        const r = st.getBoundingClientRect(), w = wall.getBoundingClientRect(), pad = 6, gx = r.width * 0.05, gy = r.height * 0.05;
        const left = Math.max(w.left, 0) + pad + gx, right = Math.min(w.right, window.innerWidth) - pad - gx;
        lim = { x0: ox + left - r.left, x1: ox + right - r.right, y0: oy + w.top + pad + gy - r.top, y1: oy + w.bottom - pad - gy - r.bottom };
        // the pack and its name stay uncovered: a sticker slides along their edge instead of going over them (one
        // that already sits over them, like the starburst on wide screens, can still be dragged away)
        const p = pack && pack.getBoundingClientRect(), m = 4;
        blocked = (x, y) => !!p && r.left + x - ox - gx < p.right + m && r.right + x - ox + gx > p.left - m &&
          r.top + y - oy - gy < p.bottom + m && r.bottom + y - oy + gy > p.top - m;
        if (blocked(ox, oy)) blocked = () => false;
        st.classList.add('is-drag');
        st.style.zIndex = ++stickerZ;
      });
      st.addEventListener('pointermove', e => {
        if (!dragging) return;
        let x = Math.min(lim.x1, Math.max(lim.x0, ox + e.clientX - sx));
        let y = Math.min(lim.y1, Math.max(lim.y0, oy + e.clientY - sy));
        if (blocked(x, y)) {
          if (!blocked(x, cy)) y = cy;
          else if (!blocked(cx, y)) x = cx;
          else return;
        }
        cx = x; cy = y;
        st.dataset.x = x; st.dataset.y = y;
        st.style.translate = `${x}px ${y}px`;
      });
      const end = () => { dragging = false; st.classList.remove('is-drag'); };
      st.addEventListener('pointerup', end);
      st.addEventListener('pointercancel', end);
    });
  });

  /* ---------- Pour story (pinned, scrubbed) ---------- */
  // index18: two real scoops, a milk bottle that pops its cap and pours a live stream, a stir that sloshes the
  // glass and swirls flavour ribbons through the milk, then the glass wakes up with a face. The milk level, the
  // stream's two ends and the stir are small proxy objects drawn by render(), so any scrub position (forwards or
  // backwards) lands on a consistent frame.
  const steps = $$('.pour__steps li');
  const setStep = i => steps.forEach((s, j) => s.classList.toggle('is-on', j === i));
  if (motion && $('#liquid')) {
    const liquid = $('#liquid'), slosh = $('#slosh'), liqCut = $('#liq-cut'), streamCut = $('#stream-cut');
    const stirArm = $('#stir-arm'), collar = $('#collar'), ribbons = $$('#ribbons path');
    const spoonTally = $('.tally--spoons'), mlOut = $('[data-ml]'), stirIcon = $('.tally--stir svg');
    const lv = { v: 0 };                 // milk level: 0 empty → 1 full (200 ml)
    const flow = { head: 92, tail: 92 }; // milk stream front and back (svg y)
    const sp = { p: 0, amp: 0 };         // stir: phase 0 → 1 (three laps) and strength
    const render = () => {
      const lift = 300 * (1 - lv.v), surf = 214 + lift;
      liquid.setAttribute('transform', `translate(0 ${lift})`);
      liqCut.setAttribute('y', surf - 4);
      streamCut.setAttribute('y', flow.tail);
      streamCut.setAttribute('height', Math.max(0, Math.min(flow.head, surf + 4, 484) - flow.tail));
      const ml = String(Math.round(lv.v * (Number(mlOut.dataset.max) || 200)));
      if (mlOut.textContent !== ml) mlOut.textContent = ml;
      const turn = sp.p * Math.PI * 6;
      const tilt = -6 * Math.sin(turn) * sp.amp, dx = 10 * Math.cos(turn) * sp.amp;
      stirArm.setAttribute('transform', `translate(${dx} 0) rotate(${tilt} 200 18)`);
      collar.setAttribute('cx', 200 + dx - 196 * Math.sin(tilt * Math.PI / 180));
      collar.setAttribute('opacity', sp.amp);
      slosh.setAttribute('transform', `rotate(${4 * Math.sin(turn - 0.9) * sp.amp} 200 350)`);
      ribbons.forEach((r, i) => r.setAttribute('transform', `translate(${(i % 2 ? 1 : -1) * ((sp.p * 300 * (1 + i * 0.3)) % 100)} 0)`));
      stirIcon.style.transform = `rotate(${sp.p * -1080}deg)`;
    };

    gsap.set('#spoon', { opacity: 0, x: 170, y: -120, rotation: 30, svgOrigin: '236 112' });
    gsap.set('#spoon-powder', { transformOrigin: '50% 100%' });
    gsap.set('#heap', { opacity: 1, scaleY: 0, scaleX: 0.85, transformOrigin: '50% 100%' });
    gsap.set('#puff circle', { opacity: 0, transformOrigin: '50% 50%' });
    gsap.set('#bottle', { opacity: 0, x: -150, y: -300, rotation: -20, svgOrigin: '208 92' });
    gsap.set('#bcap', { transformOrigin: '50% 50%' });
    gsap.set('#clouds', { opacity: 0, scale: 0.4, transformOrigin: '50% 100%' });
    gsap.set(['#ribbons', '#liqF'], { opacity: 0 });
    gsap.set('#stir', { opacity: 0, y: -340 });
    gsap.set('#straw', { opacity: 0, y: -300 });
    gsap.set('#cup', { svgOrigin: '200 490' });
    gsap.set('#foam circle', { scale: 0, transformOrigin: '50% 100%' });
    gsap.set('#bubbles', { opacity: 0 });
    gsap.set('#face .eye', { scaleY: 0, transformOrigin: '50% 50%' });
    // hidden by opacity too: a fully offset dash still paints its round cap as a dot in Chrome
    gsap.set('#face .smile', { opacity: 0, attr: { 'stroke-dashoffset': 1 } });
    gsap.set('#face .cheek', { opacity: 0, scale: 0.4, transformOrigin: '50% 50%' });
    gsap.set('#sparks path, #hearts path', { scale: 0, opacity: 0, transformOrigin: '50% 50%' });
    gsap.set(['.pour__mascot', '.pour__bubble'], { opacity: 0, y: 70, scale: 0.5 });
    spoonTally.dataset.n = 0;
    render();

    let cue = 0;
    const tl = gsap.timeline({
      defaults: { ease: 'none' },
      // step cards, their progress bars, the spoon tally and the sound cues all follow the scrubbed timeline itself
      onUpdate: () => {
        const t = tl.time(), L = tl.labels;
        if (L.done === undefined) return;
        const ends = [0, L.milk, L.stir, L.done, tl.duration()];
        setStep(t < L.milk ? 0 : t < L.stir ? 1 : t < L.done ? 2 : 3);
        steps.forEach((s, j) => s.style.setProperty('--p', gsap.utils.clamp(0, 1, (t - ends[j]) / (ends[j + 1] - ends[j]))));
        spoonTally.dataset.n = t >= L.drop1 ? 1 : 0;
        // sound effects (only if the visitor switched sound on), scrolling forwards only
        const c = ['drop1', 'pour', 'done'].filter(k => t >= L[k]).length;
        if (c > cue && window.GUD) window.GUD.sfx(c === 3 ? 'win' : c === 2 ? 'whoosh' : 'pop');
        cue = c;
      },
      scrollTrigger: { trigger: '.pour', start: 'top top', end: '+=320%', pin: '.pour__pin', scrub: 0.6 }
    });

    // 01 · two scoops: tip the spoon, powder rains down, the heap grows and puffs
    const scoop = n => tl
      .to('#spoon', { rotation: -32, duration: 0.45, ease: 'power1.inOut' }, `tip${n}`)
      .to('#spoon-powder', { scale: 0.2, opacity: 0, duration: 0.55 }, `tip${n}+=0.15`)
      .to(`#dust${n} circle`, { opacity: 1, duration: 0.05, stagger: 0.05 }, `tip${n}+=0.15`)
      .to(`#dust${n} circle`, { y: 318, duration: 0.6, stagger: 0.05, ease: 'power2.in' }, `tip${n}+=0.15`)
      .addLabel(`drop${n}`, `tip${n}+=0.7`)
      .to('#heap', { scaleY: 1, scaleX: 1, duration: 0.5, ease: 'back.out(2.5)' }, `drop${n}`)
      .set('#puff circle', { scale: 0.3, opacity: 0.9 }, `drop${n}`)
      .to('#puff circle', { scale: 1.6, opacity: 0, duration: 0.6, stagger: 0.05 }, `drop${n}`)
      .to(`#dust${n} circle`, { opacity: 0, duration: 0.05 }, `drop${n}+=0.4`);
    tl.to('#spoon', { opacity: 1, x: 0, y: 0, rotation: 0, duration: 0.9, ease: 'power2.out' })
      .addLabel('tip1');
    scoop(1);
    // one spoon: it heads off, then the milk comes
    tl.to('#spoon', { opacity: 0, x: 200, y: -160, rotation: 15, duration: 0.6, ease: 'power2.in' }, 'drop1+=0.1')

      // 02 · milk: bottle drops in beside the glass, cap pops, tips over, stream lands on the rising surface
      .addLabel('milk', 'drop1+=0.5')
      .to('#bottle', { opacity: 1, x: -150, y: 20, rotation: 0, duration: 0.8, ease: 'back.out(1.4)' }, 'milk')
      .to('#bcap', { x: -20, y: -48, rotation: -150, duration: 0.45, ease: 'power2.out' }, 'milk+=0.8')
      .to('#bcap', { opacity: 0, duration: 0.15 }, 'milk+=1.1')
      .to('#bottle', { x: 0, y: 0, rotation: 112, duration: 0.8, ease: 'power2.inOut' }, 'milk+=1')
      .addLabel('pour', 'milk+=1.75')
      .to(flow, { head: 520, duration: 0.3, ease: 'power2.in', onUpdate: render }, 'pour')
      .to('#splash', { opacity: 1, duration: 0.15 }, 'pour+=0.25')
      .to(lv, { v: 1, duration: 2.2, onUpdate: render }, 'pour+=0.2')
      .to('#bottle', { keyframes: { rotation: [112, 117, 110, 116, 112] }, duration: 2.2 }, 'pour+=0.2')
      .to('#heap', { opacity: 0, scaleY: 0.4, duration: 0.7 }, 'pour+=0.5')
      .to('#clouds', { opacity: 0.85, scale: 1, duration: 1.2, ease: 'power1.out' }, 'pour+=0.5')
      .addLabel('pourEnd', 'pour+=2.4')
      .to('#bottle', { rotation: 72, duration: 0.35, ease: 'power1.in' }, 'pourEnd')
      .to(flow, { tail: 520, duration: 0.3, ease: 'power2.in', onUpdate: render }, 'pourEnd')
      .to('#splash', { opacity: 0, duration: 0.2 }, 'pourEnd+=0.2')
      .to('#bottle', { opacity: 0, x: -60, y: -320, rotation: 40, duration: 0.7, ease: 'power2.in' }, 'pourEnd+=0.35')

      // 03 · stir: three laps, the milk sloshes, ribbons of flavour swirl until it's all one colour
      .addLabel('stir', 'pourEnd+=0.6')
      .to('#stir', { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out' }, 'stir')
      .to(sp, { amp: 1, duration: 0.35, onUpdate: render }, 'stir+=0.45')
      .to(sp, { p: 1, duration: 2.4, onUpdate: render }, 'stir+=0.45')
      .to(sp, { amp: 0, duration: 0.45, onUpdate: render }, 'stir+=2.4')
      .to('#ribbons', { opacity: 1, duration: 0.5 }, 'stir+=0.5')
      .to('#clouds', { opacity: 0, duration: 0.8 }, 'stir+=0.7')
      .to('#liqF', { opacity: 1, duration: 1.7 }, 'stir+=0.8')
      .to('#ribbons', { opacity: 0, duration: 0.6 }, 'stir+=2.2')
      .to('#stir', { opacity: 0, y: -340, duration: 0.6, ease: 'power2.in' }, 'stir+=2.85')

      // 04 · sip & smile: straw drops in, the glass bounces, foam puffs up, it opens its eyes
      .addLabel('done', 'stir+=3.3')
      .to('#straw', { opacity: 1, y: 0, duration: 0.7, ease: 'back.out(1.6)' }, 'done')
      .to('#cup', { scaleX: 1.05, scaleY: 0.93, duration: 0.15, ease: 'power1.out' }, 'done+=0.42')
      .to('#cup', { scaleX: 1, scaleY: 1, duration: 0.7, ease: 'elastic.out(1, 0.35)' }, 'done+=0.57')
      .to('#foam circle', { scale: 1, duration: 0.4, stagger: 0.03, ease: 'back.out(2.5)' }, 'done+=0.45')
      .to('#bubbles', { opacity: 1, duration: 0.3 }, 'done+=0.5')
      .to('#face .eye', { scaleY: 1, duration: 0.35, stagger: 0.08, ease: 'back.out(3)' }, 'done+=0.9')
      .set('#face .smile', { opacity: 1 }, 'done+=1')
      .to('#face .smile', { attr: { 'stroke-dashoffset': 0 }, duration: 0.35 }, 'done+=1')
      .to('#face .cheek', { opacity: 0.5, scale: 1, duration: 0.3 }, 'done+=1.15')
      .to('#sparks path, #hearts path', { scale: 1, opacity: 1, duration: 0.5, stagger: 0.06, ease: 'back.out(3)' }, 'done+=1')
      .to('.pour__mascot', { opacity: 1, y: 0, scale: 1, duration: 0.8, ease: 'back.out(1.8)' }, 'done+=1.1')
      .to('.pour__bubble', { opacity: 1, y: 0, scale: 1, duration: 0.5, ease: 'back.out(2)' }, 'done+=1.4')
      .to({}, { duration: 0.6 });
  } else {
    steps.forEach(s => s.classList.add('is-on'));
  }

  /* ---------- Journey: horizontal on desktop ---------- */
  // each journey section pins and slides its own track
  if (motion) $$('.journey').forEach(sec => {
    const track = $('.journey__track', sec), pin = $('.journey__pin', sec), bar = $('.journey__bar span', sec);
    if (!track || !pin) return;
    const mm = gsap.matchMedia();
    mm.add('(min-width: 861px)', () => {
      track.classList.add('is-pinned');
      const dist = () => Math.max(0, track.scrollWidth - window.innerWidth);
      gsap.to(track, {
        x: () => -dist(), ease: 'none',
        scrollTrigger: {
          trigger: sec, start: 'top top', end: () => '+=' + dist(), pin, scrub: 0.6, invalidateOnRefresh: true,
          onUpdate: self => { if (bar) bar.style.transform = `scaleX(${self.progress})`; }
        }
      });
      return () => { track.classList.remove('is-pinned'); gsap.set(track, { clearProps: 'x' }); };
    });
  });

  /* ---------- Jar fills on view ---------- */
  if (motion) $$('.jar').forEach(jar => {
    gsap.from($$('.layer', jar), { scaleY: 0, transformOrigin: '50% 100%', duration: 0.9, ease: 'power2.out', stagger: 0.25, scrollTrigger: { trigger: jar, start: 'top 72%' } });
    gsap.from($$('.jar__lid', jar), { y: -60, rotation: -12, opacity: 0, duration: 0.8, ease: 'back.out(2)', delay: 1.1, scrollTrigger: { trigger: jar, start: 'top 72%' } });
  });

  /* ---------- Footer curved text drifts ---------- */
  if (motion && $('.foot__curve')) {
    gsap.fromTo('.foot__curve textPath', { attr: { startOffset: '0%' } }, { attr: { startOffset: '-30%' }, ease: 'none', scrollTrigger: { trigger: '.foot', start: 'top bottom', end: 'bottom bottom', scrub: true } });
  }

  /* ---------- Footer curved text is drawn at 1:1, so selecting it highlights the right letters ---------- */
  // Chrome works out where text sits in a scaled SVG wrongly (a drag over "goodness" selected letters further on), so
  // the curve's viewBox always equals its size on screen; the path and the font size are scaled here instead
  const curve = $('.foot__curve svg');
  if (curve && curve.viewBox.baseVal) {
    const curvePath = $('path', curve), curveText = $('text', curve);
    const d0 = curvePath.getAttribute('d'), W0 = curve.viewBox.baseVal.width, H0 = curve.viewBox.baseVal.height;
    const size0 = parseFloat(getComputedStyle(curveText).fontSize);
    let fitRaf = 0;
    const fitCurve = () => {
      fitRaf = 0;
      const k = curve.getBoundingClientRect().width / W0;
      if (!k) return;
      curvePath.setAttribute('d', d0.replace(/-?\d*\.?\d+/g, n => +(n * k).toFixed(2)));
      curve.setAttribute('viewBox', `0 0 ${+(W0 * k).toFixed(2)} ${+(H0 * k).toFixed(2)}`);
      curveText.style.fontSize = +(size0 * k).toFixed(2) + 'px';
    };
    fitCurve();
    window.addEventListener('resize', () => { if (!fitRaf) fitRaf = requestAnimationFrame(fitCurve); });
  }

  /* ---------- Footer: link columns fold into tap-to-open rows on phones ---------- */
  const footCols = $$('.foot__col');
  if (footCols.length) {
    const phone = window.matchMedia('(max-width: 540px)');
    const fold = () => footCols.forEach(d => { d.open = !phone.matches; });
    fold();
    phone.addEventListener('change', fold);
    footCols.forEach(d => $('summary', d).addEventListener('click', e => { if (!phone.matches) e.preventDefault(); }));
  }

  /* ---------- Generic reveal ---------- */
  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver(entries => entries.forEach(e => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    }), { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    $$('[data-reveal]').forEach(el => io.observe(el));
  } else {
    $$('[data-reveal]').forEach(el => el.classList.add('is-in'));
  }

  /* ---------- Shop: flip, tilt, variants, buy ---------- */
  $$('.prod').forEach(prod => {
    const flip = $('.flip', prod);
    const tiltEl = $('.flip__tilt', prod);
    const stage = $('.prod__stage', prod);
    if (flip) flip.addEventListener('click', () => {
      const on = !flip.classList.contains('is-flipped');
      flip.classList.toggle('is-flipped', on);
      flip.setAttribute('aria-pressed', String(on));
    });
    if (stage && tiltEl && fine && !reduce) {
      stage.addEventListener('pointermove', e => {
        const r = stage.getBoundingClientRect();
        tiltEl.style.setProperty('--ry', (((e.clientX - r.left) / r.width - 0.5) * 30).toFixed(2) + 'deg');
        tiltEl.style.setProperty('--rx', (-((e.clientY - r.top) / r.height - 0.5) * 20).toFixed(2) + 'deg');
      });
      stage.addEventListener('pointerleave', () => { tiltEl.style.setProperty('--ry', '0deg'); tiltEl.style.setProperty('--rx', '0deg'); });
    }
  });

  /* ---------- Shop on phones: swipe between packs; the switch follows and recolours the page ---------- */
  // one switch per shop section
  $$('.prods').forEach(prodTrack => {
    const sec = prodTrack.closest('section') || document;
    const prodBtns = $$('[data-prod-go]', sec);
    if (!prodBtns.length) return;
    const cards = $$('.prod', prodTrack);
    const dots = $$('.prods__dots i', sec);
    const swipes = () => getComputedStyle(prodTrack).overflowX === 'auto';
    const centre = c => c.offsetLeft + c.offsetWidth / 2;
    let active = -1, settle = 0;
    const mark = i => {
      active = i;
      prodBtns.forEach((b, j) => b.setAttribute('aria-pressed', String(j === i)));
      dots.forEach((d, j) => d.classList.toggle('is-on', j === i));
    };
    const show = (i, smooth) => {
      if (!cards[i]) return;
      mark(i);
      if (swipes()) prodTrack.scrollTo({ left: centre(cards[i]) - prodTrack.clientWidth / 2, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    };
    prodBtns.forEach(b => b.addEventListener('click', () => {
      const i = Number(b.dataset.prodGo);
      show(i, true);
      if (cards[i] && cards[i].dataset.product) goFlavor(cards[i].dataset.product);
    }));
    prodTrack.addEventListener('scroll', () => {
      clearTimeout(settle);
      settle = setTimeout(() => {
        const mid = prodTrack.scrollLeft + prodTrack.clientWidth / 2;
        const best = cards.reduce((b, c, i) => (Math.abs(centre(c) - mid) < Math.abs(centre(cards[b]) - mid) ? i : b), 0);
        if (best === active) return;
        mark(best);
        const f = cards[best].dataset.product;
        if (f && body.dataset.flavor !== f) applyFlavor(f);
      }, 140);
    }, { passive: true });
    // open on the flavour the visitor already picked, and follow later changes
    const sync = f => { const i = cards.findIndex(c => c.dataset.product === f); if (i >= 0) show(i, false); };
    document.addEventListener('gud:flavor', e => sync(e.detail));
    sync(body.dataset.flavor);
    if (active < 0) mark(0);
  });

  // product forms are rendered by sections/gudsip-shop.liquid: one radio per variant (name="id"), price and pack
  // images carried on data attributes. Without JavaScript the form still posts to the cart.
  $$('[data-buy]').forEach(form => {
    const prod = form.closest('.prod, .pdp') || form; // homepage card or product page
    const qtyInput = $('.qty input', form);
    const submit = $('button[type="submit"]', form);
    const selected = () => $('input[name="id"]:checked', form) || $('input[name="id"]', form);
    // swap: a size was picked, so show its own photo; on page load the server-rendered photo stays
    const update = swap => {
      const v = selected();
      if (!v) return;
      const price = $('[data-price]', form);
      if (price && v.dataset.price) price.textContent = v.dataset.price;
      const front = $('.flip__front, [data-pdp-main]', prod), back = $('.flip__back', prod);
      // srcset beats src, so it goes too, or the browser keeps showing the old photo
      if (swap && front && v.dataset.front && front.getAttribute('src') !== v.dataset.front) {
        front.removeAttribute('srcset');
        front.src = v.dataset.front;
        if (back) { back.removeAttribute('srcset'); back.src = v.dataset.back || v.dataset.front; }
      }
      if (submit) submit.disabled = v.dataset.available === 'false';
    };
    update(false);
    form.addEventListener('change', e => update(e.target.name === 'id')); // a quantity change keeps the photo shown
    form.addEventListener('click', e => {
      const step = e.target.closest('[data-step]');
      if (step) qtyInput.value = clamp(Number(qtyInput.value) + Number(step.dataset.step), 1, 20);
    });
    qtyInput.addEventListener('change', () => { qtyInput.value = clamp(Number(qtyInput.value), 1, 20); });
    form.addEventListener('submit', e => {
      const v = selected();
      if (!v || !window.fetch) return;
      e.preventDefault();
      addToCart(Number(v.value), clamp(Number(qtyInput.value), 1, 20), submit);
    });
  });

  /* ---------- Ask the gud block ---------- */
  // questions come from sections/gudsip-faq.liquid (one block each); the answer rides on data-answer
  $$('.ask').forEach(sec => {
    const chipList = $('.ask__chips', sec);
    const qEl = $('.ask__q', sec), aEl = $('.ask__a', sec), live = $('[data-ask-live]', sec), askMascot = $('.ask__mascot', sec);
    let typeTimer = null;
    if (!chipList || !qEl || !aEl) return;
    chipList.addEventListener('click', e => {
      const b = e.target.closest('[data-q]');
      if (!b) return;
      const item = { q: b.textContent.trim(), a: b.dataset.answer || '' };
      $$('.chip', chipList).forEach(c => c.setAttribute('aria-pressed', String(c === b)));
      qEl.textContent = item.q;
      if (live) live.textContent = item.q + ' ' + item.a;
      clearInterval(typeTimer);
      if (reduce) { aEl.textContent = item.a; return; }
      aEl.textContent = '';
      let n = 0;
      typeTimer = setInterval(() => { n += 2; aEl.textContent = item.a.slice(0, n); if (n >= item.a.length) clearInterval(typeTimer); }, 16);
      if (askMascot) { askMascot.classList.remove('is-jump'); void askMascot.offsetWidth; askMascot.classList.add('is-jump'); }
    });
  });

  /* ---------- Cart drawer (Shopify Ajax Cart API) ---------- */
  const cartEl = $('.cart'), scrim = $('.scrim'), list = $('.cart__items'), countEls = $$('[data-count]');
  let lastFocus = null;
  let busy = false;
  cartEl.inert = true;
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const thumb = url => url + (url.includes('?') ? '&' : '?') + 'width=160';
  async function cartRequest(url, data) {
    const r = await fetch(url, {
      method: data ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: data ? JSON.stringify(data) : undefined
    });
    const json = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(json.description || json.message || T.cartError || 'Something went wrong. Please try again.');
    return json;
  }
  function renderCart(c) {
    list.innerHTML = c.items.map(it => {
      const meta = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) + ' · ' : '';
      return `<li class="ci">
        <div class="ci__img">${it.image ? `<img src="${esc(thumb(it.image))}" alt="" width="56" height="78" loading="lazy">` : ''}</div>
        <div><p class="ci__name">${esc(it.product_title)}</p><p class="ci__meta">${meta}${money(it.final_price)}</p>
          <div class="qty qty--sm"><button type="button" data-ci="${esc(it.key)}" data-qty="${it.quantity - 1}" aria-label="${esc((T.less || 'One less') + ' ' + it.product_title)}">−</button><span>${it.quantity}</span><button type="button" data-ci="${esc(it.key)}" data-qty="${it.quantity + 1}" aria-label="${esc((T.more || 'One more') + ' ' + it.product_title)}">+</button></div></div>
        <div class="ci__end"><p class="ci__total">${money(it.final_line_price)}</p><button class="ci__remove" type="button" data-ci="${esc(it.key)}" data-qty="0">${esc(T.remove || 'Remove')}</button></div>
      </li>`;
    }).join('');
    countEls.forEach(el => { el.textContent = c.item_count; });
    $('[data-subtotal]').textContent = money(c.total_price);
    cartEl.classList.toggle('is-empty', c.item_count === 0);
  }
  const refreshCart = () => cartRequest(ROUTES.cart + '.js').then(renderCart).catch(() => {});
  async function addToCart(id, quantity, button) {
    if (busy) return;
    busy = true;
    if (button) button.setAttribute('aria-busy', 'true');
    try {
      await cartRequest(ROUTES.add + '.js', { items: [{ id, quantity }] });
      renderCart(await cartRequest(ROUTES.cart + '.js'));
      countEls.forEach(el => { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
      openCart();
    } catch (err) {
      toast(err.message);
    } finally {
      busy = false;
      if (button) button.removeAttribute('aria-busy');
    }
  }
  list.addEventListener('click', async e => {
    const b = e.target.closest('[data-ci]');
    if (!b || busy) return;
    busy = true;
    try {
      const c = await cartRequest(ROUTES.change + '.js', { id: b.dataset.ci, quantity: Math.max(0, Number(b.dataset.qty)) });
      renderCart(c);
      if (!c.items.some(it => it.key === b.dataset.ci)) $('.cart__close').focus();
    } catch (err) {
      toast(err.message);
    } finally {
      busy = false;
    }
  });
  function openCart() {
    if (cartOpen) return;
    cartOpen = true;
    lastFocus = document.activeElement;
    cartEl.inert = false;
    cartEl.classList.add('is-open');
    scrim.classList.add('is-open');
    cartEl.setAttribute('aria-hidden', 'false');
    nav.classList.remove('is-hidden');
    syncLock();
    setTimeout(() => $('.cart__close').focus(), 80);
  }
  function closeCart() {
    if (!cartOpen) return;
    cartOpen = false;
    cartEl.classList.remove('is-open');
    scrim.classList.remove('is-open');
    cartEl.setAttribute('aria-hidden', 'true');
    cartEl.inert = true;
    syncLock();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeCart(); if (menuOpen) setMenu(false); return; }
    if (e.key !== 'Tab' || !cartOpen) return;
    const f = $$('button, a[href], input', cartEl).filter(el => el.offsetParent !== null);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  refreshCart();
  // the cart may have changed on another page (back/forward cache)
  window.addEventListener('pageshow', e => { if (e.persisted) refreshCart(); });

  /* ---------- Toast + newsletter ---------- */
  const toastEl = $('.toast');
  let toastTimer;
  function toast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-show'), 3000);
  }
  // the Gud Club form posts to Shopify (newsletter signup); sections/gudsip-footer.liquid leaves the result here
  const clubNote = $('[data-club-note]');
  if (clubNote && clubNote.textContent.trim()) setTimeout(() => toast(clubNote.textContent.trim()), 700);

  $$('[data-year]').forEach(el => { el.textContent = new Date().getFullYear(); });
  // the scroll scenes are measured in page order: a pinned scene adds scroll length, so one placed below another
  // (sections can be reordered in the Shopify theme editor) must be measured after it
  const sortTriggers = () => { if (ScrollTrigger.sort) ScrollTrigger.sort(); ScrollTrigger.refresh(); };
  if (motion) { sortTriggers(); window.addEventListener('load', sortTriggers); }
})();

/* ===== Kids edition: shared effects (sound, particles, eyes, mascot, bubbles, letters, scroll glass) ===== */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* storage unavailable */ } }
  };
  const GUD = window.GUD = { reduce, fine, store };

  /* ---------- Sound: tiny WebAudio synth, off until the visitor turns it on ---------- */
  let ac = null;
  let soundOn = store.get('gudsip-sound') === '1';
  const soundBtn = $('[data-sound-toggle]') || document.createElement('button');
  if (!soundBtn.isConnected) soundOn = false;
  function audio() {
    if (!ac) { const AC = window.AudioContext || window.webkitAudioContext; if (!AC) return null; ac = new AC(); }
    if (ac.state === 'suspended') ac.resume();
    return ac;
  }
  function tone({ f = 440, f2 = f, t = 0.12, type = 'sine', v = 0.18, delay = 0 }) {
    const a = audio(); if (!a) return;
    const now = a.currentTime + delay;
    const o = a.createOscillator(), g = a.createGain();
    o.type = type;
    o.frequency.setValueAtTime(f, now);
    o.frequency.exponentialRampToValueAtTime(Math.max(30, f2), now + t);
    g.gain.setValueAtTime(0.0001, now);
    g.gain.exponentialRampToValueAtTime(v, now + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0001, now + t);
    o.connect(g).connect(a.destination);
    o.start(now); o.stop(now + t + 0.03);
  }
  function noise(t, v, freq) {
    const a = audio(); if (!a) return;
    const len = Math.floor(a.sampleRate * t);
    const buf = a.createBuffer(1, len, a.sampleRate);
    const d = buf.getChannelData(0);
    for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / len);
    const src = a.createBufferSource(), bp = a.createBiquadFilter(), g = a.createGain();
    src.buffer = buf; bp.type = 'bandpass'; bp.frequency.value = freq; bp.Q.value = 1.4; g.gain.value = v;
    src.connect(bp).connect(g).connect(a.destination);
    src.start();
  }
  const SFX = {
    pop: () => tone({ f: 900, f2: 1900, t: 0.08, v: 0.2 }),
    boing: () => tone({ f: 170, f2: 640, t: 0.3, type: 'triangle', v: 0.22 }),
    tick: () => tone({ f: 1250, f2: 1000, t: 0.05, type: 'square', v: 0.05 }),
    coin: () => { tone({ f: 988, t: 0.08, type: 'square', v: 0.06 }); tone({ f: 1319, t: 0.18, type: 'square', v: 0.06, delay: 0.08 }); },
    buzz: () => tone({ f: 170, f2: 80, t: 0.32, type: 'sawtooth', v: 0.08 }),
    slurp: () => noise(0.16, 0.2, 600 + Math.random() * 600),
    whoosh: () => noise(0.55, 0.22, 450),
    win: () => [523, 659, 784, 1047].forEach((f, i) => tone({ f, t: 0.24, type: 'triangle', v: 0.16, delay: i * 0.11 })),
    cart: () => { tone({ f: 660, t: 0.1, type: 'triangle', v: 0.15 }); tone({ f: 990, t: 0.22, type: 'triangle', v: 0.15, delay: 0.09 }); }
  };
  GUD.sfx = name => { if (soundOn && SFX[name]) { try { SFX[name](); } catch (e) { /* audio blocked */ } } };
  soundBtn.setAttribute('aria-pressed', String(soundOn));
  soundBtn.addEventListener('click', () => {
    soundOn = !soundOn;
    soundBtn.setAttribute('aria-pressed', String(soundOn));
    store.set('gudsip-sound', soundOn ? '1' : '0');
    GUD.sfx('pop');
  });

  /* ---------- Sprites built from the page's own icon symbols ---------- */
  const sprites = {};
  ['berry', 'choco', 'cube', 'drop'].forEach(k => {
    const sym = document.getElementById('i-' + k);
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${sym.getAttribute('viewBox')}">${sym.innerHTML}</svg>`;
    const img = new Image();
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    sprites[k] = img;
  });
  GUD.sprites = sprites;
  GUD.ratio = { berry: 72 / 60, choco: 52 / 72, cube: 1, drop: 1 };

  /* ---------- Particle layer (confetti, sparkles, bubbles) ---------- */
  const cv = $('.fx'), ctx = cv.getContext('2d');
  let parts = [], raf = 0, dpr = 1;
  const COLORS = ['#D91F2E', '#FFC21C', '#F26A1B', '#5A2614', '#F7B7C0', '#FFFFFF', '#54A044', '#3B82C4'];
  function size() { dpr = Math.min(2, window.devicePixelRatio || 1); cv.width = innerWidth * dpr; cv.height = innerHeight * dpr; }
  size();
  window.addEventListener('resize', size);
  function star(r) {
    ctx.beginPath();
    for (let i = 0; i < 8; i++) { const a = (i * Math.PI) / 4, rr = i % 2 ? r * 0.34 : r; ctx.lineTo(Math.cos(a) * rr, Math.sin(a) * rr); }
    ctx.closePath(); ctx.fill();
  }
  function loop() {
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, innerWidth, innerHeight);
    parts = parts.filter(p => p.life > 0 && p.y < innerHeight + 80);
    for (const p of parts) {
      p.life--; p.vy += p.g; p.vx *= p.drag; p.vy *= p.drag; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
      ctx.save();
      ctx.globalAlpha = Math.min(1, p.life / 25);
      ctx.translate(p.x, p.y); ctx.rotate(p.rot);
      if (p.img) {
        if (p.img.complete) ctx.drawImage(p.img, -p.s / 2, (-p.s * p.ar) / 2, p.s, p.s * p.ar);
      } else if (p.kind === 'bubble') {
        ctx.fillStyle = 'rgba(255,255,255,.55)'; ctx.strokeStyle = 'rgba(43,20,9,.28)'; ctx.lineWidth = 1.2;
        ctx.beginPath(); ctx.arc(0, 0, p.s, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
      } else if (p.kind === 'star') {
        ctx.fillStyle = p.c; star(p.s);
      } else {
        ctx.fillStyle = p.c; ctx.scale(1, Math.cos(p.rot * 2)); ctx.fillRect(-p.s / 2, -p.s / 4, p.s, p.s / 2);
      }
      ctx.restore();
    }
    raf = parts.length ? requestAnimationFrame(loop) : 0;
    if (!raf) ctx.clearRect(0, 0, innerWidth, innerHeight);
  }
  function add(p) { parts.push(p); if (!raf) raf = requestAnimationFrame(loop); }
  function piece(x, y, vx, vy, g, life) {
    const base = { x, y, vx, vy, g, drag: 0.986, rot: Math.random() * 6, vr: (Math.random() - 0.5) * 0.3, life };
    const r = Math.random();
    if (r < 0.55) return { ...base, kind: 'star', c: Math.random() < 0.6 ? '#FFC21C' : '#FFFFFF', s: 4 + Math.random() * 5 };
    return { ...base, kind: 'paper', c: COLORS[(Math.random() * COLORS.length) | 0], s: 6 + Math.random() * 6 };
  }
  GUD.burst = (x, y, n = 18, power = 1) => {
    if (reduce) return;
    for (let i = 0; i < n; i++) {
      const a = Math.random() * Math.PI * 2, sp = (3 + Math.random() * 6) * power;
      add(piece(x, y, Math.cos(a) * sp, Math.sin(a) * sp - 4 * power, 0.32, 70 + Math.random() * 40));
    }
  };
  GUD.rain = (n = 120) => {
    if (reduce) return;
    for (let i = 0; i < n; i++) {
      setTimeout(() => add(piece(Math.random() * innerWidth, -30, (Math.random() - 0.5) * 2, 2 + Math.random() * 3, 0.05, 320)), i * 16);
    }
  };



  /* Flavour whoosh and cart celebration only (no burst on regular cursor click) */
  document.addEventListener('click', e => {
    if (e.target.closest('[data-flavor-go]')) GUD.sfx('whoosh');
  });
  document.addEventListener('submit', e => {
    if (!e.target.matches('[data-buy]')) return;
    const b = $('button[type="submit"]', e.target).getBoundingClientRect();
    GUD.burst(b.left + b.width / 2, b.top + b.height / 2, 24, 0.9);
    GUD.sfx('cart');
  }, true);

  /* ---------- Googly eyes on every mascot ---------- */
  // Eye geometry of the packet mascot (assets/mascot-*.webp, 760x800): [cx, cy, eye radius, iris radius]
  const EYE_DATA = [[321, 345, 54, 43], [517, 377, 54, 43]];
  const MASCOT_W = 760, MASCOT_H = 800;
  // ids are per face: clip paths and gradients inside hidden faces are not reliably shared across SVGs
  const EYES = k => `<svg class="eyes eyes--live" viewBox="0 0 ${MASCOT_W} ${MASCOT_H}" aria-hidden="true"><defs><radialGradient id="iris${k}" cx="62%" cy="70%" r="70%"><stop offset="0" stop-color="#9A4A1E"/><stop offset=".55" stop-color="#4A1B0A"/><stop offset="1" stop-color="#220903"/></radialGradient>` +
    EYE_DATA.map(([cx, cy, r], i) => `<clipPath id="eyeclip${k}-${i}"><circle cx="${cx}" cy="${cy}" r="${r}"/></clipPath>`).join('') + '</defs>' +
    EYE_DATA.map(([cx, cy, r, pr], i) =>
      `<g class="eye"><circle class="eye__skin" cx="${cx}" cy="${cy}" r="${r + 6}"/><g class="eye__ball"><circle class="eye__white" cx="${cx}" cy="${cy}" r="${r}"/><g clip-path="url(#eyeclip${k}-${i})"><g class="eye__pupil" style="transform:translate(-13px,-5px)"><circle class="eye__iris" cx="${cx}" cy="${cy}" r="${pr}" fill="url(#iris${k})"/><circle class="eye__core" cx="${cx}" cy="${cy}" r="${Math.round(pr * 0.52)}"/><circle class="eye__glint" cx="${cx + 10}" cy="${cy - 20}" r="10"/></g></g><circle class="eye__rim" cx="${cx}" cy="${cy}" r="${r - 1}"/></g></g>`
    ).join('') + '</svg>';
  const faces = $$('[data-face]');
  faces.forEach((f, k) => f.insertAdjacentHTML('beforeend', EYES(k)));
  let lookX = null, lookY = null, lastMove = 0, eyeRaf = 0;
  function aim() {
    eyeRaf = 0;
    faces.forEach(face => {
      const r = face.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight || !r.width) return;
      $$('.eye__pupil', face).forEach((p, i) => {
        const [cx, cy, er, pr] = EYE_DATA[i];
        const ex = r.left + (cx / MASCOT_W) * r.width, ey = r.top + (cy / MASCOT_H) * r.height;
        const dx = lookX - ex, dy = lookY - ey, d = Math.hypot(dx, dy) || 1;
        const m = Math.min(1, d / 260) * (er - pr + 3);
        p.style.transform = `translate(${((dx / d) * m).toFixed(1)}px,${((dy / d) * m).toFixed(1)}px)`;
      });
    });
  }
  window.addEventListener('pointermove', e => { lookX = e.clientX; lookY = e.clientY; lastMove = Date.now(); if (!eyeRaf) eyeRaf = requestAnimationFrame(aim); }, { passive: true });
  window.addEventListener('pointerdown', e => { lookX = e.clientX; lookY = e.clientY; lastMove = Date.now(); aim(); }, { passive: true });
  window.addEventListener('scroll', () => { if (lookX !== null && !eyeRaf) eyeRaf = requestAnimationFrame(aim); }, { passive: true });
  if (!reduce) {
    setInterval(() => {
      if (Date.now() - lastMove < 3000) return;
      lookX = Math.random() * innerWidth; lookY = Math.random() * innerHeight; aim();
    }, 2200);
    faces.forEach(face => {
      const svg = $('.eyes--live', face);
      const blink = () => {
        svg.classList.add('is-blink');
        setTimeout(() => svg.classList.remove('is-blink'), 130);
        setTimeout(blink, 2200 + Math.random() * 3800);
      };
      setTimeout(blink, 1000 + Math.random() * 3000);
    });
  }

  /* ---------- Talking hero mascot (tap 5 times fast for a party) ---------- */
  const LINES = ['Hi! I’m a block of real jaggery!', '“Gud” means jaggery in Hindi!', 'Made with real jaggery!', 'One spoon + 100 ml milk = yum!', 'No refined sugar in here!', 'Hot or cold? I like both!', 'Strawberry or chocolate? Why not both!', 'Psst… try the Kids’ corner!', 'Hee hee, that tickles!'];
  let lineIdx = 1, taps = 0, tapTimer = 0;
  function say(bubble, text) {
    bubble.hidden = false;
    bubble.textContent = text;
    bubble.style.animation = 'none'; void bubble.offsetWidth; bubble.style.animation = '';
    clearTimeout(bubble._t);
    bubble._t = setTimeout(() => { bubble.hidden = true; }, 2800);
  }
  function hop(el) { el.classList.remove('is-hop'); void el.offsetWidth; el.classList.add('is-hop'); }
  $$('[data-face]').forEach(f => f.addEventListener('animationend', e => { if (e.animationName === 'hop') f.classList.remove('is-hop'); }));
  $$('[data-talk]').forEach(face => {
    const bubble = $('.say', face.parentElement);
    const talk = () => {
      hop(face);
      say(bubble, LINES[lineIdx++ % LINES.length]);
      GUD.sfx('boing');
      const r = face.getBoundingClientRect();
      GUD.burst(r.left + r.width / 2, r.top + r.height * 0.3, 10, 0.7);
      taps++; clearTimeout(tapTimer); tapTimer = setTimeout(() => { taps = 0; }, 1600);
      if (taps >= 5) { taps = 0; party(); }
    };
    face.addEventListener('click', talk);
    face.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); talk(); } });
    if (!reduce) setTimeout(() => say(bubble, LINES[0]), 3400);
  });

  /* ---------- Poppable milk bubbles in the hero (disabled) ---------- */

  /* ---------- Bouncy letters on headings ---------- */
  if (!reduce) {
    $$('h2, .hero__title').forEach(h => {
      h.setAttribute('aria-label', (h.innerText || h.textContent).replace(/\s+/g, ' ').trim());
      const walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) if (walker.currentNode.textContent.trim()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        const frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(part => {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          const word = document.createElement('span');
          word.style.cssText = 'display:inline-block;white-space:nowrap';
          word.setAttribute('aria-hidden', 'true');
          for (const ch of part) { const s = document.createElement('span'); s.className = 'wob'; s.textContent = ch; word.appendChild(s); }
          frag.appendChild(word);
        });
        node.replaceWith(frag);
      });
    });
    document.addEventListener('pointerover', e => {
      const w = e.target.closest('.wob');
      if (!w || w.classList.contains('is-boing')) return;
      w.classList.add('is-boing');
      w.addEventListener('animationend', () => w.classList.remove('is-boing'), { once: true });
    });
  }

  /* ---------- Scroll-progress glass ---------- */
  const sg = $('.sglass'), sgFill = $('[data-sg-fill]'), sgPct = $('[data-sg-pct]');
  let sgRaf = 0;
  function updSG() {
    sgRaf = 0;
    const max = document.documentElement.scrollHeight - innerHeight;
    const p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
    sgFill.setAttribute('transform', `translate(0 ${(80 - 74 * p).toFixed(1)})`);
    sgPct.textContent = Math.round(p * 100) + '%';
    sg.classList.toggle('is-top', window.scrollY < 300);
  }
  window.addEventListener('scroll', () => { if (!sgRaf) sgRaf = requestAnimationFrame(updSG); }, { passive: true });
  updSG();
  sg.addEventListener('click', () => { GUD.sfx('whoosh'); $('.nav__logo').click(); });

  /* ---------- Gud party: type g-u-d anywhere ---------- */
  const toastEl = $('.toast');
  function party() {
    GUD.sfx('win');
    GUD.rain(150);
    $$('[data-face]').forEach(hop);
    toastEl.textContent = 'It’s a gud party!';
    toastEl.classList.add('is-show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-show'), 2800);
  }
  GUD.party = party;
  let typed = '';
  document.addEventListener('keydown', e => {
    if ((e.target.closest && e.target.closest('input, textarea')) || e.key.length !== 1) return;
    typed = (typed + e.key.toLowerCase()).slice(-3);
    if (typed === 'gud') { typed = ''; party(); }
  });
})();

/* ===== Reviews ("Happy sippers"): filter, arrows, drag, pop-in ===== */
(() => {
  'use strict';
  // review cards and the score badge are rendered by sections/gudsip-reviews.liquid (one block per review)
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const TILT = [-1.5, 1, -0.6, 1.4];
  // one review wall per reviews section
  $$('.love').forEach(section => {
    const track = $('[data-rv-track]', section), prev = $('[data-rv-prev]', section), next = $('[data-rv-next]', section);
    if (!track) return;
    const cards = $$('.rv', track); // every review, in the order set in the theme editor

    function arrows() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    function render(filter) {
      const shown = cards.filter(c => filter === 'all' || c.dataset.flavor === filter);
      shown.forEach((c, i) => { c.style.setProperty('--i', i); c.style.setProperty('--r', TILT[i % TILT.length] + 'deg'); });
      track.replaceChildren(...shown);
      track.scrollLeft = 0;
      arrows();
    }
    render('all');

    // cards pop in one after another the first time the track scrolls into view
    if ('IntersectionObserver' in window && !reduce) {
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        section.classList.add('is-in');
        io.disconnect();
      }, { threshold: 0.2 });
      io.observe(track);
    } else {
      section.classList.add('is-in');
    }

    const filters = $$('[data-rv-filter]', section);
    filters.forEach(b => b.addEventListener('click', () => {
      filters.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      const shown = section.classList.contains('is-in');
      section.classList.remove('is-in');
      render(b.dataset.rvFilter);
      if (shown) { void track.offsetWidth; section.classList.add('is-in'); } // replay the pop-in for the new set
      if (window.GUD) window.GUD.sfx('tick');
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    }));

    const step = () => {
      const card = $('.rv', track);
      return card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : 300;
    };
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', arrows, { passive: true });
    window.addEventListener('resize', arrows);

    // mouse drag (touch already swipes natively)
    let drag = null;
    track.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: track.scrollLeft };
    });
    window.addEventListener('pointermove', e => {
      if (!drag) return;
      const dx = e.clientX - drag.x;
      if (Math.abs(dx) > 4) track.classList.add('is-drag');
      track.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!drag) return;
      drag = null;
      track.classList.remove('is-drag');
    });
  });
})();

/* ===== Extra motion: heading letters hop in and squiggles draw, numbers count up, ingredient rows, FAQ chips and
   footer columns pop in, ingredient piles drift. Each part checks for its own markup, so it also runs on pages that
   only have some of these sections. ===== */
(() => {
  'use strict';
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) { $$('h2').forEach(h => h.classList.add('is-drawn')); return; }
  const motion = !!(window.gsap && window.ScrollTrigger);

  // runs fn once el is in view: by default when 60% of it shows (anything that can be seen gets there, even at the
  // very bottom of a page); { rootMargin: '0px 0px -28% 0px' } instead means "its top passes 72% of the screen",
  // like ScrollTrigger's start: 'top 72%'
  const onView = (el, fn, opts = { threshold: 0.6 }) => {
    const io = new IntersectionObserver(([e]) => {
      // the first report comes straight away and can be "intersecting" below the threshold, so check the ratio too
      if (!e.isIntersecting || e.intersectionRatio < (opts.threshold || 0) * 0.99) return;
      io.disconnect();
      fn();
    }, opts);
    io.observe(el);
  };

  /* ---------- Headings: letters hop in one by one, then a squiggle draws under the script word ---------- */
  // the squiggle only spans the last line of the script word, so a word that wraps on a phone isn't underlined across
  // the empty space beside it (the words are the inline-block spans made by "Bouncy letters" in the effects script)
  const fitSquiggle = em => {
    let boxes = Array.from(em.children).filter(w => w.offsetWidth).map(w => ({ top: w.offsetTop, left: w.offsetLeft, right: w.offsetLeft + w.offsetWidth }));
    if (!boxes.length && em.textContent.trim()) {
      // plain text (no word spans yet, e.g. a heading the theme editor just re-drew): measure its lines unrotated
      const range = document.createRange();
      range.selectNodeContents(em);
      const turn = em.style.transform;
      em.style.transform = 'none';
      const base = em.getBoundingClientRect();
      boxes = Array.from(range.getClientRects()).filter(b => b.width).map(b => ({ top: b.top - base.top, left: b.left - base.left, right: b.right - base.left }));
      em.style.transform = turn;
    }
    if (!boxes.length) return;
    const top = Math.max(...boxes.map(b => b.top));
    const last = boxes.filter(b => top - b.top < 4);
    const left = Math.min(...last.map(b => b.left));
    em.style.setProperty('--sq-l', left + 'px');
    em.style.setProperty('--sq-w', Math.max(...last.map(b => b.right)) - left + 'px');
  };
  // measured when each heading comes into view (its fonts have loaded by then), and again when fonts or the width change
  const fitAll = () => $$('h2 em').forEach(fitSquiggle);
  if (window.GUD) window.GUD.fitSquiggles = fitAll; // the Shopify theme editor calls it after re-drawing a section
  if (document.fonts) document.fonts.addEventListener('loadingdone', fitAll);
  let fitTimer = 0;
  window.addEventListener('resize', () => { clearTimeout(fitTimer); fitTimer = setTimeout(fitAll, 150); });

  // the letters are the .wob spans made by "Bouncy letters" in the effects script
  $$('h2').forEach(h => {
    const letters = $$('.wob', h);
    const n = Math.min(letters.length, 40);
    if (n) {
      letters.forEach((l, i) => l.style.setProperty('--li', Math.min(i, 40)));
      h.classList.add('lt-wait');
    }
    onView(h, () => {
      $$('em', h).forEach(fitSquiggle);
      h.classList.add('is-drawn');
      if (!n) return;
      h.classList.add('lt-go');
      // once they have landed, the letters go back to their hover bounce
      setTimeout(() => h.classList.remove('lt-wait', 'lt-go'), n * 28 + 1000);
    });
  });

  /* ---------- Numbers count up from 0 ("45%", "30%"…) ---------- */
  const countUp = (el, delay = 0) => {
    const final = el.textContent;
    const m = final.trim().match(/^(\d{1,3})(\D{0,3})$/);
    if (!m) return;
    const end = Number(m[1]);
    el.textContent = '0' + m[2];
    setTimeout(() => {
      const start = performance.now();
      const tick = now => {
        const p = Math.min(1, (now - start) / 1100);
        if (p < 1) { el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))) + m[2]; requestAnimationFrame(tick); }
        else el.textContent = final;
      };
      requestAnimationFrame(tick);
    }, delay);
  };
  // the jar's layers fill bottom-up, 0.25 s apart (see "Jar fills on view")
  $$('.jar').forEach(jar => onView(jar, () => $$('.layer-txt', jar).forEach((t, i) => countUp(t, i * 250)), { rootMargin: '0px 0px -28% 0px' }));
  // the 45% sticker lands about half a second after the sticker wall comes in
  $$('.stickers').forEach(wall => onView(wall, () => $$('.sticker--round b', wall).forEach(b => countUp(b, 500)), { rootMargin: '0px 0px -22% 0px' }));

  /* ---------- What's inside: list rows slide in bottom-up, in step with the jar ---------- */
  $$('.mixlist').forEach(list => {
    const rows = $$('li', list).reverse();
    if (motion) gsap.set(rows, { opacity: 0, x: 40 });
    onView(list, () => {
      if (motion) gsap.to(rows, { opacity: 1, x: 0, duration: 0.7, ease: 'back.out(1.6)', stagger: 0.15, clearProps: 'opacity,transform' });
      rows.forEach((r, i) => { const b = r.querySelector('b'); if (b) countUp(b, i * 150); });
    }, { threshold: 0.3 });
  });

  if (!motion) return;

  /* ---------- FAQ: question chips pop in one after another ---------- */
  $$('.ask__stage').forEach(stage => {
    const chips = $$('.ask__chips li', stage);
    if (!chips.length) return;
    gsap.set(chips, { opacity: 0, scale: 0.4, y: 30 });
    onView(stage, () => gsap.to(chips, { opacity: 1, scale: 1, y: 0, duration: 0.6, ease: 'back.out(2.2)', stagger: 0.07, clearProps: 'opacity,transform' }), { rootMargin: '0px 0px -35% 0px' });
  });

  /* ---------- Footer: brand and link columns rise in one after another ---------- */
  $$('.foot__grid').forEach(grid => {
    const cols = Array.from(grid.children);
    gsap.set(cols, { opacity: 0, y: 40 });
    onView(grid, () => gsap.to(cols, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out', stagger: 0.1, clearProps: 'opacity,transform' }), { threshold: 0.2 });
  });

  /* ---------- Shop: the ingredient piles drift a little slower than the packs (desktop) ---------- */
  gsap.matchMedia().add('(min-width: 861px) and (hover: hover)', () => {
    $$('.prod__ingr').forEach(img => gsap.fromTo(img, { y: 50 }, {
      y: -30, ease: 'none',
      scrollTrigger: { trigger: img.closest('.prod') || img, start: 'top bottom', end: 'bottom top', scrub: true }
    }));
  });
})();


/* ===== Product page (sections/gudsip-product.liquid): gallery thumbnails and fold-outs; theme editor refresh ===== */
(() => {
  'use strict';
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const DESIGN = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Gallery: thumbnails swap the big picture ---------- */
  function initGallery(root) {
    const main = root.querySelector('[data-pdp-main]');
    const thumbs = $$('[data-pdp-thumb]', root);
    if (!main || !thumbs.length) return;
    // each photo is fetched once in the background (same 1x/2x choice as the big image), so a tap swaps it at once
    const warm = b => {
      if (!b._img) {
        b._img = new Image();
        if (b.dataset.srcset) b._img.srcset = b.dataset.srcset;
        b._img.src = b.dataset.src;
      }
      return b._img;
    };
    if (document.readyState === 'complete') thumbs.forEach(warm);
    else window.addEventListener('load', () => thumbs.forEach(warm));
    thumbs.forEach(b => {
      b.addEventListener('pointerenter', () => warm(b));
      b.addEventListener('click', () => {
        // the tap shows at once; the big image dims until its photo is ready, then fades in
        thumbs.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        const img = warm(b);
        if (!img.complete) main.classList.add('is-loading');
        (img.decode ? img.decode() : Promise.resolve()).catch(() => {}).then(() => {
          if (b.getAttribute('aria-pressed') !== 'true') return; // another thumbnail was tapped meanwhile
          main.srcset = b.dataset.srcset || '';
          main.src = b.dataset.src;
          main.alt = b.dataset.alt || '';
          main.classList.remove('is-loading');
          if (!reduce && main.animate) main.animate([{ opacity: 0, scale: 0.92 }, { opacity: 1, scale: 1 }], { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1.15)' });
        });
      });
    });
    // the arrows on the big picture step through the thumbnails, round and round
    $$('[data-pdp-step]', root).forEach(btn => btn.addEventListener('click', () => {
      const i = Math.max(0, thumbs.findIndex(x => x.getAttribute('aria-pressed') === 'true'));
      thumbs[(i + Number(btn.dataset.pdpStep) + thumbs.length) % thumbs.length].click();
    }));
  }

  /* ---------- Fold-outs (description, ingredients, how to make a glass): slide open and shut, one open at a time ---------- */
  function initFolds(root) {
    const items = $$('.pdp__acc details', root);
    if (!items.length) return;
    const EASE = 'cubic-bezier(.22,1,.36,1)';
    // "open" for the visitor: still marked open while it slides shut, so check the closing flag too
    const isOpen = d => d.open && !d.classList.contains('is-closing');
    const run = (d, open) => {
      const summary = d.querySelector('summary'), body = summary.nextElementSibling;
      const from = d.offsetHeight; // where it is right now, even halfway through a slide
      if (d._anim) d._anim.cancel(); // a cancelled slide never runs its finish step
      if (d._fade) d._fade.cancel();
      // once shut, the text's fade-out is dropped so it shows normally the next time
      const finish = () => { d._anim = null; if (!open) { d.open = false; if (d._fade) d._fade.cancel(); } d.classList.remove('is-closing'); };
      if (open) d.open = true;
      d.classList.toggle('is-closing', !open);
      const to = open ? d.offsetHeight : summary.offsetHeight + (d.offsetHeight - d.clientHeight); // shut = summary + borders
      if (reduce || !d.animate || from === to) { finish(); return; }
      d._anim = d.animate({ height: [from + 'px', to + 'px'] }, { duration: open ? 420 : 320, easing: EASE });
      d._anim.onfinish = finish;
      if (body && body.animate) {
        d._fade = body.animate(open ? { opacity: [0, 1], transform: ['translateY(-8px)', 'none'] } : { opacity: [1, 0] },
          { duration: open ? 380 : 200, delay: open ? 60 : 0, easing: EASE, fill: open ? 'backwards' : 'forwards' });
      }
    };
    // theme editor: each setting change re-draws the section with every box shut, so the box the merchant opened is
    // remembered for this tab and opened again, letting them watch their edit (shop visitors always start all shut)
    const KEY = 'gudsip-pdp-open';
    const name = d => d.dataset.acc || d.querySelector('summary').textContent.trim();
    if (DESIGN) {
      let saved = [];
      try { saved = JSON.parse(sessionStorage.getItem(KEY)) || []; } catch (e) { /* storage unavailable */ }
      items.forEach(d => { if (saved.includes(name(d))) d.open = true; });
    }
    const remember = () => {
      if (!DESIGN) return;
      try { sessionStorage.setItem(KEY, JSON.stringify(items.filter(isOpen).map(name))); } catch (e) { /* storage unavailable */ }
    };
    items.forEach(d => d.querySelector('summary').addEventListener('click', e => {
      e.preventDefault();
      const opening = !isOpen(d);
      if (opening) items.forEach(o => { if (o !== d && isOpen(o)) run(o, false); });
      run(d, opening);
      remember();
    }));
  }

  const pick = form => form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
  // counts a number up or down to its new value (straight to it with reduced motion, or the first time)
  const tween = (el, to, fmt) => {
    const from = el._v == null ? to : el._v;
    el._v = to;
    cancelAnimationFrame(el._raf);
    if (reduce || from === to) { el.textContent = fmt(to); return; }
    const start = performance.now();
    const step = now => {
      const p = Math.min(1, (now - start) / 380);
      el.textContent = fmt(from + (to - from) * (1 - Math.pow(1 - p, 3)));
      if (p < 1) el._raf = requestAnimationFrame(step);
    };
    el._raf = requestAnimationFrame(step);
  };
  // a pack's net weight, read from its size name ("400 g bottle", "1 kg jar"); 0 when the name has none
  const packGrams = radio => {
    const m = (radio ? radio.closest('label').textContent : '').match(/(\d+(?:[.,]\d+)?)\s*(kg|g)\b/i);
    return m ? Math.round(parseFloat(m[1].replace(',', '.')) * (m[2].toLowerCase() === 'kg' ? 1000 : 1)) : 0;
  };

  /* ---------- Mascot: says hello when the pack comes into view, and something new with each tap ---------- */
  function initBuddy(root) {
    $$('[data-pdp-buddy]', root).forEach(btn => {
      const say = btn.parentElement.querySelector('[data-pdp-say]');
      const lines = (btn.dataset.lines || '').split('|').map(s => s.trim()).filter(Boolean);
      if (!say || !lines.length) return;
      let i = 0;
      const pop = text => { say.textContent = text; say.classList.remove('is-pop'); void say.offsetWidth; say.classList.add('is-pop'); };
      btn.addEventListener('click', () => {
        i = (i + 1) % lines.length;
        pop(lines[i]);
        if (window.GUD && window.GUD.sfx) window.GUD.sfx('boing');
      });
      if (!('IntersectionObserver' in window)) { pop(lines[0]); return; }
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        setTimeout(() => pop(lines[0]), reduce ? 0 : 700);
      }, { threshold: 0.5 });
      io.observe(btn);
    });
  }

  /* ---------- Flavour switch: going to the other flavour keeps the pack size picked here, when it has one ---------- */
  function initFlavourLinks(root) {
    $$('.pdp', root).forEach(pdp => {
      const form = pdp.querySelector('[data-buy]');
      const links = $$('[data-flv-variants]:not([aria-current])', pdp);
      if (!form || !links.length) return;
      form.addEventListener('change', e => {
        if (e.target.name !== 'id') return;
        const title = e.target.dataset.title;
        links.forEach(a => {
          let map = {};
          try { map = JSON.parse(a.dataset.flvVariants); } catch (err) { /* keep the plain product link */ }
          a.href = a.dataset.flvBase + (map[title] && Object.keys(map).length > 1 ? '?variant=' + map[title] : '');
        });
      });
    });
  }

  /* ---------- Delivery checker: says only what the merchant set (or that checkout shows the details) ---------- */
  function initPin(root) {
    $$('[data-pin]', root).forEach(form => {
      const d = form.dataset, input = form.querySelector('input'), out = form.querySelector('.pin__out');
      const buy = (form.closest('.pdp') || document).querySelector('[data-buy]');
      const list = (d.list || '').split(/[\s,;]+/).filter(p => /^\d{1,6}$/.test(p));
      try { const last = localStorage.getItem('gudsip-pin'); if (last) input.value = last; } catch (e) { /* storage unavailable */ }
      const show = (ok, lines) => {
        form.classList.toggle('is-ok', ok);
        form.classList.toggle('is-bad', !ok);
        out.replaceChildren(...lines.filter(Boolean).map(t => { const s = document.createElement('span'); s.textContent = t; return s; }));
        out.classList.remove('is-new'); void out.offsetWidth; out.classList.add('is-new');
      };
      input.addEventListener('input', () => {
        const v = input.value.replace(/\D/g, '').slice(0, 6);
        if (v !== input.value) input.value = v;
        if (form.classList.contains('is-bad')) { form.classList.remove('is-bad'); out.replaceChildren(); }
      });
      form.addEventListener('submit', e => {
        e.preventDefault();
        const pin = input.value.trim();
        if (!/^[1-9]\d{5}$/.test(pin)) { show(false, [d.msgInvalid]); input.focus(); return; }
        try { localStorage.setItem('gudsip-pin', pin); } catch (err) { /* storage unavailable */ }
        const fill = s => s.split('%pin').join(pin);
        if (d.mode === 'list' && !list.some(p => pin.startsWith(p))) { show(false, [fill(d.msgNo)]); return; }
        const lines = d.mode === 'checkout' ? [fill(d.msgCheckout)] : [fill(d.msgYes), d.msgEta];
        lines.push(d.msgFee);
        if (d.free) {
          // free delivery: this pack size times the quantity picked, against the merchant's amount
          const r = buy && pick(buy), qty = buy ? Math.max(1, Number(buy.querySelector('input[name="quantity"]').value) || 1) : 1;
          lines.push(r && Number(r.dataset.cents) * qty >= Number(d.free) ? d.msgFreeYes : d.msgFree);
        }
        show(true, lines);
      });
    });
  }

  /* ---------- Serving calculator: glasses → powder, milk, and what one pack covers ---------- */
  function initPlan(root) {
    $$('[data-plan]', root).forEach(plan => {
      const d = plan.dataset, serving = Number(d.serving) || 25, milk = Number(d.milk) || 200, spoons = Number(d.tbsp) || 0;
      const q = s => plan.querySelector(s);
      const nOut = q('[data-plan-n]'), range = q('[data-plan-range]'), say = q('[data-plan-say]'), live = q('[data-plan-live]');
      const powder = q('[data-plan-powder]'), tbsp = q('[data-plan-tbsp]'), milkOut = q('[data-plan-milk]');
      const pack = q('[data-plan-pack]'), packLabel = q('[data-plan-pack-label]'), left = q('[data-plan-left]'), used = q('[data-plan-used]');
      const form = (plan.closest('.pdp') || document).querySelector('[data-buy]');
      const word = (k, n) => (n === 1 ? d[k + 'One'] : d[k + 'Other']).replace('%n', n);
      const ml = v => { v = Math.round(v); return v >= 1000 ? Math.round(v / 100) / 10 + ' L' : v + ' ml'; };
      let n = 1, grams = 0;
      const render = first => {
        nOut.textContent = n;
        range.value = n;
        tween(powder, n * serving, v => Math.round(v));
        if (spoons) tbsp.textContent = d.tbspLabel.replace('%n', n * spoons);
        tween(milkOut, n * milk, ml);
        pack.hidden = !grams;
        if (grams) {
          const per = Math.floor(grams / serving);
          packLabel.textContent = d.packLabel.replace('%g', grams);
          left.textContent = n <= per ? word('left', per - n) : word('packs', Math.ceil((n * serving) / grams));
          used.style.width = Math.min(100, (n * serving * 100) / grams) + '%';
        }
        say.textContent = word('say', n);
        if (first) return;
        say.classList.remove('is-pop'); void say.offsetWidth; say.classList.add('is-pop');
        live.textContent = word('say', n) + ' ' + n * serving + ' g, ' + ml(n * milk) + '.';
      };
      const set = v => { n = Math.min(32, Math.max(1, Math.round(v) || 1)); render(); };
      plan.addEventListener('click', e => { const b = e.target.closest('[data-plan-step]'); if (b) set(n + Number(b.dataset.planStep)); });
      range.addEventListener('input', () => set(Number(range.value)));
      const readPack = () => { grams = form ? packGrams(pick(form)) : 0; };
      if (form) form.addEventListener('change', e => { if (e.target.name === 'id') { readPack(); render(); } });
      readPack();
      render(true);
    });
  }

  /* ---------- Sticky Add to cart bar (phones and tablets) ---------- */
  // Shown once the buy button has scrolled up out of view; hidden again while the FAQ or the footer is on screen,
  // so their buttons and links are never covered. Its button submits the real product form (same cart drawer).
  function initBar(root) {
    $$('.pdp', root).forEach(pdp => {
      const bar = pdp.querySelector('[data-pdp-bar]'), form = pdp.querySelector('[data-buy]');
      if (!bar || !form || !('IntersectionObserver' in window)) return;
      const add = bar.querySelector('[data-bar-add]'), price = bar.querySelector('[data-bar-price]'), label = bar.querySelector('[data-bar-variant]');
      const small = window.matchMedia('(max-width: 960px)');
      const sync = () => {
        const r = pick(form);
        if (!r) return;
        const p = form.querySelector('[data-price]');
        if (p) price.textContent = p.textContent;
        const name = r.closest('label').querySelector('span');
        label.textContent = (name.firstChild && name.firstChild.nodeType === 3 ? name.firstChild.textContent : name.textContent).trim();
        add.disabled = r.dataset.available === 'false';
      };
      form.addEventListener('change', sync);
      sync();
      add.addEventListener('click', () => {
        const submit = form.querySelector('button[type="submit"]');
        if (form.requestSubmit) form.requestSubmit(submit); else if (submit) submit.click();
      });
      let passed = false;
      const near = new Set();
      const set = () => {
        const on = passed && !near.size;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', String(!on));
        bar.inert = !on;
        document.body.classList.toggle('has-pdp-bar', on);
      };
      new IntersectionObserver(([e]) => { passed = !e.isIntersecting && e.boundingClientRect.bottom < 0; set(); })
        .observe(form.querySelector('.buy__row') || form);
      const ends = new IntersectionObserver(entries => {
        entries.forEach(e => (e.isIntersecting ? near.add(e.target) : near.delete(e.target)));
        set();
      });
      $$('.ask, .foot').forEach(el => ends.observe(el));
      small.addEventListener('change', set);
      set();
    });
  }

  /* ---------- Header search: the panel, live suggestions from Shopify while typing, keyboard moves ---------- */
  // Suggestions are sections/gudsip-search-results.liquid, drawn by Shopify's predictive search (Section Rendering
  // API). Without this script the button is a plain link to the search page, and the form still posts there.
  function initSearch(root) {
    $$('[data-search]', root).forEach(panel => {
      const opener = document.querySelector('[aria-controls="' + panel.id + '"]');
      const scrim = panel.previousElementSibling && panel.previousElementSibling.matches('.search-scrim') ? panel.previousElementSibling : null;
      const input = panel.querySelector('[data-search-input]'), results = panel.querySelector('[data-search-results]');
      const popular = panel.querySelector('[data-search-popular]'), status = panel.querySelector('[data-search-status]');
      const nav = document.querySelector('.nav'), html = document.documentElement;
      const cache = new Map();
      let ctrl = null, timer = 0, back = opener; // back: where focus returns on close (the button or link that opened it)
      panel.inert = true;
      const isOpen = () => panel.classList.contains('is-open');
      const set = (open, from) => {
        // the panel hangs just under the header bar (its height changes with the screen size)
        if (open && nav) panel.style.setProperty('--search-top', nav.offsetTop + nav.offsetHeight + 'px');
        if (open) back = from || opener;
        panel.classList.toggle('is-open', open);
        html.classList.toggle('search-open', open);
        panel.inert = !open;
        panel.setAttribute('aria-hidden', String(!open));
        if (opener) opener.setAttribute('aria-expanded', String(open));
        if (open) setTimeout(() => { input.focus({ preventScroll: true }); input.select(); }, 60);
        else if (back && (panel.contains(document.activeElement) || document.activeElement === document.body)) back.focus({ preventScroll: true });
      };
      const put = (part, term) => {
        results.replaceChildren();
        if (part) results.append(part.cloneNode(true));
        const said = results.querySelector('[data-search-said]');
        status.textContent = said ? said.textContent : '';
        if (popular) popular.hidden = !!term;
      };
      const find = () => {
        const term = input.value.trim();
        clearTimeout(timer);
        if (ctrl) ctrl.abort();
        if (!term) { put(null, ''); panel.classList.remove('is-loading'); return; }
        if (cache.has(term)) { put(cache.get(term), term); return; }
        ctrl = new AbortController();
        panel.classList.add('is-loading');
        const url = panel.dataset.url + '?q=' + encodeURIComponent(term) + '&section_id=gudsip-search-results'
          + '&resources[type]=product,collection,page,article&resources[limit]=4&resources[options][unavailable_products]=last';
        fetch(url, { signal: ctrl.signal })
          .then(r => { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(text => {
            const part = new DOMParser().parseFromString(text, 'text/html').querySelector('.search__results');
            cache.set(term, part);
            if (input.value.trim() === term) put(part, term);
          })
          .catch(err => {
            if (err.name === 'AbortError') return;
            const p = document.createElement('p');
            p.className = 'search__none';
            p.textContent = panel.dataset.error;
            put(p, term);
          })
          .finally(() => { if (input.value.trim() === term) panel.classList.remove('is-loading'); });
      };
      input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(find, 220); });
      // other links to the search page (see below) open the panel, with their search words when they carry some
      panel.addEventListener('gudsip:search-open', e => {
        const { from, q } = e.detail || {};
        if (q) input.value = q;
        set(true, from);
        if (q) find();
      });
      if (opener) {
        opener.addEventListener('click', e => { e.preventDefault(); set(!isOpen()); });
        opener.addEventListener('keydown', e => { if (e.key === ' ') { e.preventDefault(); set(!isOpen()); } });
      }
      $$('[data-search-close]', panel).concat(scrim ? [scrim] : []).forEach(b => b.addEventListener('click', () => set(false)));
      // the header's other buttons (menu, cart, sound) close the panel first
      if (nav) nav.addEventListener('click', e => { if (isOpen() && !e.target.closest('[data-search-open]')) set(false); });
      panel.addEventListener('keydown', e => {
        if (e.key === 'Escape') { e.preventDefault(); set(false); return; }
        const items = $$('input[type="search"], a, button', panel).filter(el => el.offsetParent !== null);
        const links = items.filter(el => el.matches('a'));
        const at = links.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' && (document.activeElement === input || at >= 0)) {
          e.preventDefault();
          (links[at + 1] || links[0] || input).focus();
        } else if (e.key === 'ArrowUp' && at >= 0) {
          e.preventDefault();
          (links[at - 1] || input).focus();
        } else if (e.key === 'Tab' && items.length) {
          // focus stays inside the panel while it is open
          const first = items[0], lastEl = items[items.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
          else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
        }
      });
    });
  }

  // Any other link to the search page (the footer's "Search", a menu item…) opens the same panel instead of the plain
  // search page. Ctrl/cmd/shift/middle clicks and new-tab links still open the page as usual.
  document.addEventListener('click', e => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href]'), panel = document.querySelector('[data-search]');
    if (!a || !panel || a.target === '_blank' || panel.contains(a) || a.matches('[data-search-open]')) return;
    const form = panel.querySelector('form');
    const url = new URL(a.href, location.href), page = new URL(form ? form.action : '/search', location.href);
    if (url.origin !== location.origin || url.pathname !== page.pathname) return;
    e.preventDefault();
    // the menu overlay closes first, so the panel isn't left on top of it
    if (document.documentElement.classList.contains('menu-open')) { const m = document.querySelector('.nav__menu'); if (m) m.click(); }
    panel.dispatchEvent(new CustomEvent('gudsip:search-open', { detail: { from: a, q: url.searchParams.get('q') || '' } }));
  });

  /* ---------- Banner: the pieces follow the pointer, the pack turns a little while the page scrolls ---------- */
  function initBanner(root) {
    if (reduce) return;
    $$('[data-banner]', root).forEach(bn => {
      const art = bn.querySelector('.bn__art');
      if (!art) return;
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        bn.addEventListener('pointermove', e => {
          const r = bn.getBoundingClientRect();
          art.style.setProperty('--px', (((e.clientX - r.left) / r.width - 0.5) * 2).toFixed(3));
          art.style.setProperty('--py', (((e.clientY - r.top) / r.height - 0.5) * 2).toFixed(3));
        });
        bn.addEventListener('pointerleave', () => { art.style.setProperty('--px', 0); art.style.setProperty('--py', 0); });
      }
      // --turn: -1 as the banner enters at the bottom of the screen, 1 as it leaves at the top
      let raf = 0;
      const turn = () => {
        raf = 0;
        const r = bn.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        const p = (innerHeight - r.top) / (innerHeight + r.height);
        art.style.setProperty('--turn', (p * 2 - 1).toFixed(3));
      };
      window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(turn); }, { passive: true });
      turn();
    });
  }

  /* ---------- Menu: links to homepage sections follow the order of those sections ---------- */
  // The merchant moves sections in the theme editor, so the "#shop"-style links in the header bar and the overlay are
  // put in the order their sections sit on the homepage, renumbered, and hidden when the homepage has no such section.
  // Other pages have none of those sections, so they reuse the order last seen on the homepage (or keep the menu's own).
  const MENU_KEY = 'gudsip-menu-order';
  function orderMenu() {
    const boxes = $$('.menu__links, .nav__links'), logo = document.querySelector('.nav__logo');
    const homePath = logo ? new URL(logo.href, location.href).pathname : '/';
    const homeLinks = box => $$('a', box).filter(a => a.hash.length > 1 && a.pathname === homePath);
    const all = boxes.flatMap(homeLinks);
    if (!all.length) return;
    let order;
    if (location.pathname === homePath) {
      const target = a => { try { return document.querySelector(decodeURIComponent(a.hash)); } catch (e) { return null; } };
      const found = [...new Set(all.filter(target).map(a => a.hash))];
      order = found.sort((a, b) => (target({ hash: a }).compareDocumentPosition(target({ hash: b })) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
      all.forEach(a => { a.hidden = !order.includes(a.hash); });
      try { localStorage.setItem(MENU_KEY, JSON.stringify(order)); } catch (e) { /* storage blocked */ }
    } else {
      try { order = JSON.parse(localStorage.getItem(MENU_KEY) || 'null'); } catch (e) { order = null; }
      if (!Array.isArray(order) || !order.length) return;
    }
    const rank = a => { const i = order.indexOf(a.hash); return i < 0 ? order.length : i; };
    boxes.forEach(box => {
      const links = homeLinks(box);
      const sorted = links.slice().sort((a, b) => rank(a) - rank(b));
      const slots = links.map(a => { const mark = document.createComment(''); a.replaceWith(mark); return mark; });
      sorted.forEach((a, i) => slots[i].replaceWith(a));
      $$('a', box).filter(a => !a.hidden).forEach((a, i) => {
        a.style.setProperty('--i', i);
        const num = a.querySelector('small');
        if (num) num.textContent = String(i + 1).padStart(2, '0');
      });
    });
  }

  /* ---------- "Real food" cards: on phones a swipe slider; its dots follow the card in the middle ---------- */
  function initMwSlider(root) {
    $$('.mw__board', root).forEach(board => {
      const track = board.querySelector('.mw__cards'), dots = $$('.mw__dots i', board);
      if (!track || !dots.length) return;
      const cards = $$('.mw__card', track);
      let raf = 0;
      const mark = () => {
        raf = 0;
        const t = track.getBoundingClientRect(), mid = t.left + t.width / 2;
        const gap = c => { const r = c.getBoundingClientRect(); return Math.abs(r.left + r.width / 2 - mid); };
        const on = cards.reduce((best, c, i) => (gap(c) < gap(cards[best]) ? i : best), 0);
        dots.forEach((d, i) => d.classList.toggle('is-on', i === on));
      };
      track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(mark); }, { passive: true });
    });
  }

  /* ---------- "What's inside": its flavour switch changes only this section ---------- */
  // the jar, its label and the section's colours follow the switch (data-mix, gudsip.css); the page keeps its flavour
  function initMix(root) {
    $$('.inside', root).forEach(sec => {
      const btns = $$('[data-mix-flavor]', sec);
      if (!btns.length) return;
      const set = f => {
        sec.dataset.mix = f;
        btns.forEach(b => b.setAttribute('aria-checked', String(b.dataset.mixFlavor === f)));
      };
      btns.forEach(b => b.addEventListener('click', () => set(b.dataset.mixFlavor)));
      set(document.body.dataset.flavor === 'strawberry' ? 'strawberry' : 'chocolate');
    });
  }

  const init = root => {
    initBanner(root);
    initMwSlider(root);
    initMix(root);
    initSearch(root);
    initGallery(root);
    initFolds(root);
    initBuddy(root);
    initFlavourLinks(root);
    initPin(root);
    initPlan(root);
    initBar(root);
  };
  init(document);
  orderMenu();

  /* ---------- Theme editor: a changed section is re-drawn in place ---------- */
  // Reloading the preview would close the editor's settings panel (and end its session), so instead the new
  // section is shown at once, scroll scenes that lost their markup are dropped, and the product page parts above
  // are wired up again. Pinned scenes in a re-drawn section (pour, journey) stay still until the preview is refreshed.
  if (!DESIGN) return;
  const settle = root => {
    $$('[data-reveal], .love', root).forEach(el => el.classList.add('is-in')); // scroll reveals and review pop-ins
    $$('h2', root).forEach(h => h.classList.add('is-drawn')); // heading squiggles, fitted to the new headings
    if (window.GUD && window.GUD.fitSquiggles) window.GUD.fitSquiggles();
    if (window.ScrollTrigger) {
      window.ScrollTrigger.getAll().forEach(t => { if (t.trigger && !document.contains(t.trigger)) t.kill(); });
      if (window.ScrollTrigger.sort) window.ScrollTrigger.sort(); // page order, after sections are moved
      window.ScrollTrigger.refresh();
    }
  };
  document.addEventListener('shopify:section:load', e => {
    settle(e.target);
    init(e.target);
    orderMenu();
  });
  ['shopify:section:unload', 'shopify:section:reorder'].forEach(ev => document.addEventListener(ev, () => setTimeout(() => { settle(document); orderMenu(); }, 0)));
})();
